import { render, staticRenderFns } from "./ActEvaluasiPraktekMandiri.vue?vue&type=template&id=2861bd90&"
import script from "./ActEvaluasiPraktekMandiri.vue?vue&type=script&lang=js&"
export * from "./ActEvaluasiPraktekMandiri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports